export enum SchedulerApprovalType {
  ShopManager = 'ShopManager',
  RegionalManager = 'RegionalManager'
}
